import {
  ADD_MESSAGE,
  DELETE_MESSAGE
} from './flashMessage.actionTypes';

let timeoutId = null;

export function addSuccessMessage(text, title, intlTextKey, intlTitleKey) {
  return dispatch => {
    clearMessageTimer();

    // Display success message
    dispatch(successMessage(text, title, intlTextKey, intlTitleKey));

    // After 5 seconds go and dismiss it
    timeoutId = setTimeout(function () {
      dispatch(dismissMessage());
    }, 5000);

  };
}

export function addErrorMessage(text, title, intlTextKey, intlTitleKey) {
  return dispatch => {
    clearMessageTimer();

    // Display error message
    dispatch(errorMessage(text, title, intlTextKey, intlTitleKey));
  };
}

export function addErrorMessageWithTimeout(text, title, intlTextKey, intlTitleKey) {
  return dispatch => {
    clearMessageTimer();

    // Display error message
    dispatch(errorMessage(text, title, intlTextKey, intlTitleKey));

    timeoutId = setTimeout(function () {
      dispatch(dismissMessage());
    }, 5000);
  };
}

export function addInfoMessage(text, title, intlTextKey, intlTitleKey) {

  return dispatch => {
    clearMessageTimer();

    // Display info message
    dispatch(infoMessage(text, title, intlTextKey, intlTitleKey));
  };
}

export function dismissMessage() {
  return {
    type: DELETE_MESSAGE
  };
}


export function successMessage(text, title, intlTextKey, intlTitleKey) {
  return {
    type: ADD_MESSAGE,
    message: {
      text: text || 'Success.',
      title: title ? `${title} : ` : ``,
      type: 'success',
      intlTextKey: intlTextKey,
      intlTitleKey: intlTitleKey, 
    }
  };
}

export function errorMessage(text, title, intlTextKey, intlTitleKey) {
  return {
    type: ADD_MESSAGE,
    message: {
      text: text || 'There was an issue with your request. Please see details below.',
      title: title ? `${title} : ` : ``,
      type: 'error',
      intlTextKey: intlTextKey,
      intlTitleKey: intlTitleKey, 
    }
  };
}

export function infoMessage(text, title, intlTextKey, intlTitleKey) {
  return {
    type: ADD_MESSAGE,
    message: {
      text: text || 'Success.',
      title: title ? `${title} : ` : ``,
      type: 'information',
      intlTextKey: intlTextKey,
      intlTitleKey: intlTitleKey,     
    }
  };
}

export function clearMessageTimer() {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }
}
